export var LessonState = {
    STARTED: 'STARTED',
    PAUSED: 'PAUSED',
    STOPPED: 'STOPPED',
};
export var Messages = {
    INVALID_ACTION: 'Invalid Action',
};
export var config = {
    ButtonClickDelay: 700,
    WindowShowDelay: 1000,
    ButtonTypeAnimationDelay: 100,
    NextActionDelay: 1000,
    DoAnimateTyping: false,
};
export var TargettedSystems = {
    CATIZ: 'CATIZ',
    S80: 'S80',
    HERMESYS: 'HERMESYS',
};
//# sourceMappingURL=constants.js.map